// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

export class GetEngagementById {
  chatId: string;
  engagementId: string;
}
